module.exports = "https://la-static.prod-my.games/minigames/collection/img/row_5.0fd9e33a.png";